export enum RegistrationGaVersion {
  Replatform = 'replatform',
  NewRepo = 'new-repo',
}
